import { Link } from "react-router-dom";
import { ArrowRight, Cpu, Wrench, Factory } from "lucide-react";

const SiloEntryBlocks = () => (
  <section className="py-14 lg:py-20 bg-background" aria-label="Product silos">
    <div className="container">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {/* Automation silo */}
        <article className="group relative overflow-hidden rounded-2xl border border-border bg-card hover:border-brand/40 transition-all duration-300 hover:shadow-xl">
          <div className="p-8 md:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center">
                <Cpu className="w-6 h-6 text-brand" />
              </div>
              <span className="text-xs font-display uppercase tracking-wider text-muted-foreground">Factory Automation</span>
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-3">
              Industrial Automation Parts
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              PLCs, HMIs, servo drives, VFDs, power supplies, communication modules and I/O systems from the world's leading OEMs. Real inventory in the USA.
            </p>
            <ul className="space-y-2 mb-7 text-sm text-foreground/80">
              <li>• 8,000+ SKUs in stock — same-day shipping</li>
              <li>• Active, discontinued and obsolete catalog numbers</li>
              <li>• 2-year Nardy Automation warranty</li>
            </ul>
            <Link
              to="/industrial-automation-parts"
              className="inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all"
            >
              Enter Automation Hub
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </article>

        {/* Repair Services silo */}
        <article className="group relative overflow-hidden rounded-2xl border border-border bg-card hover:border-brand/40 transition-all duration-300 hover:shadow-xl">
          <div className="p-8 md:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center">
                <Wrench className="w-6 h-6 text-brand" />
              </div>
              <span className="text-xs font-display uppercase tracking-wider text-muted-foreground">Industrial Repair</span>
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-3">
              Automation Repair Services
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Component-level repair of PLCs, HMIs, servo drives, VFDs, power supplies, CNC controllers and industrial PCBs — restored to OEM specification with a 12-month performance warranty.
            </p>
            <ul className="space-y-2 mb-7 text-sm text-foreground/80">
              <li>• Allen-Bradley, Siemens, ABB, Fanuc, Yaskawa, Lenze</li>
              <li>• 5–10 day turnaround, 24/7 emergency service</li>
              <li>• Free evaluation and transparent quote</li>
            </ul>
            <Link
              to="/industrial-automation-repair-services"
              className="inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all"
            >
              Enter Repair Hub
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </article>

        {/* Manufacturers silo */}
        <article className="group relative overflow-hidden rounded-2xl border border-border bg-card hover:border-brand/40 transition-all duration-300 hover:shadow-xl md:col-span-2 lg:col-span-1">
          <div className="p-8 md:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center">
                <Factory className="w-6 h-6 text-brand" />
              </div>
              <span className="text-xs font-display uppercase tracking-wider text-muted-foreground">Global OEMs</span>
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-3">
              Shop by Manufacturer
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Dedicated catalogs for Allen-Bradley, Siemens, ABB, Schneider Electric, Mitsubishi, FANUC, Beckhoff, Omron, Bosch Rexroth, Lenze, B&amp;R and more.
            </p>
            <ul className="space-y-2 mb-7 text-sm text-foreground/80">
              <li>• 30+ manufacturer landing pages</li>
              <li>• Series-level browsing (ControlLogix, SIMATIC, PowerFlex…)</li>
              <li>• Cross-reference &amp; obsolete part sourcing</li>
            </ul>
            <Link
              to="/manufacturers"
              className="inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all"
            >
              Browse Manufacturers
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default SiloEntryBlocks;
